/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetOrganizationGatewayActivityPayload,
  GetOrganizationGatewayActivityPayload$Outbound,
  GetOrganizationGatewayActivityPayload$outboundSchema,
} from "../components/getorganizationgatewayactivitypayload.js";

export type GetOrganizationGatewayUsageSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetOrganizationGatewayUsageRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  getOrganizationGatewayActivityPayload: GetOrganizationGatewayActivityPayload;
};

/** @internal */
export type GetOrganizationGatewayUsageSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetOrganizationGatewayUsageSecurity$outboundSchema: z.ZodMiniType<
  GetOrganizationGatewayUsageSecurity$Outbound,
  GetOrganizationGatewayUsageSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getOrganizationGatewayUsageSecurityToJSON(
  getOrganizationGatewayUsageSecurity: GetOrganizationGatewayUsageSecurity,
): string {
  return JSON.stringify(
    GetOrganizationGatewayUsageSecurity$outboundSchema.parse(
      getOrganizationGatewayUsageSecurity,
    ),
  );
}

/** @internal */
export type GetOrganizationGatewayUsageRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  GetOrganizationGatewayActivityPayload:
    GetOrganizationGatewayActivityPayload$Outbound;
};

/** @internal */
export const GetOrganizationGatewayUsageRequest$outboundSchema: z.ZodMiniType<
  GetOrganizationGatewayUsageRequest$Outbound,
  GetOrganizationGatewayUsageRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    getOrganizationGatewayActivityPayload:
      GetOrganizationGatewayActivityPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      getOrganizationGatewayActivityPayload:
        "GetOrganizationGatewayActivityPayload",
    });
  }),
);

export function getOrganizationGatewayUsageRequestToJSON(
  getOrganizationGatewayUsageRequest: GetOrganizationGatewayUsageRequest,
): string {
  return JSON.stringify(
    GetOrganizationGatewayUsageRequest$outboundSchema.parse(
      getOrganizationGatewayUsageRequest,
    ),
  );
}
